import transfer from '@/api/transfer'
import { mergeUserContext } from '@/store/helpers'

// initial state
const state = {
  transferRecordResponse: false,
  transferOrganizations: []
}

const getters = {
  transferRecordResponse: state => state.transferRecordResponse,
  transferOrganizations: state => state.transferOrganizations
}

const actions = {
  async transferRecord ({ commit, state, rootState }, payload) {
    const modelName = payload.modelName
    let caseModelName = modelName.charAt(0).toUpperCase() + modelName.slice(1)

    payload = mergeUserContext(payload, rootState)

    let response = await transfer.transferRecord(payload)
    response = response.body

    // Tell corresponding models to update their data based on the transfer response
    if (response.success) {
      let data = response.data
      let editRecordBag = modelName === 'laborscreening' ? 'laborScreening' : 'view' + caseModelName
      let existingRecord = rootState[modelName + 's'][editRecordBag]
      let pk = modelName === 'note' ? 'id' : '_id'

      if (existingRecord[pk] === data[pk]) {
        // The only thing that should have changed is the organizationOwner and some timestamps, only merge data that changed
        let updatedFields = _.pick(data, [ 'organizationOwner', 'updatedAt', 'updatedBy' ])
        let newRecord = Object.assign({}, existingRecord, updatedFields)

        // In store/person, store/assessment, and store/note go update our "view record"
        commit('UPDATE_TRANSFERRED_' + modelName.toUpperCase(), newRecord, { root: true })
      }
    }
    commit('SET_TRANSFER_RECORD_RESPONSE', response)
  },

  async getTransferOrganizations ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await transfer.getTransferOrganizations(payload)
    response = response.body

    commit('UPDATE_TRANSFER_ORGANIZATIONS', response)
  }

}

const mutations = {
  SET_TRANSFER_RECORD_RESPONSE (state, response) {
    const formattedResponse = this._vm.$utils.responseHandler(response)
    state.transferRecordResponse = formattedResponse
  },
  UPDATE_TRANSFER_ORGANIZATIONS (state, response) {
    state.transferOrganizations = response
  },

  RESET_TRANSFER_ORGANIZATIONS (state, response) {
    state.transferOrganizations = []
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/transfer.js